var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicyBeneficiaries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16868",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12506",
    d: "M12.469 3.023a3.492 3.492 0 11-4.938 0 3.492 3.492 0 014.938 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12507",
    d: "M14.363 12.8A11.938 11.938 0 0010 11.991c-4.048 0-8 1.967-8 4.992v1a1 1 0 001 1h9.413"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12508",
    d: "M17 22a5 5 0 01-5-5 5.077 5.077 0 015-5 5 5 0 010 10"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12509",
    d: "M17.986 15.25a1.448 1.448 0 011.414 1.439c0 1.408-2.357 2.561-2.4 2.561s-2.4-1.153-2.4-2.561a1.448 1.448 0 011.414-1.439 1.3 1.3 0 01.986.428 1.3 1.3 0 01.986-.428z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12510",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgPolicyBeneficiaries;


//////////////////
// WEBPACK FOOTER
// ./src/icons/policyBeneficiaries.svg
// module id = 787
// module chunks = 13